import { render, staticRenderFns } from "./oaNotice.vue?vue&type=template&id=263247b5&scoped=true"
import script from "./oaNotice.vue?vue&type=script&lang=js"
export * from "./oaNotice.vue?vue&type=script&lang=js"
import style0 from "./oaNotice.vue?vue&type=style&index=0&id=263247b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263247b5",
  null
  
)

export default component.exports